import { startScrollSpy } from '@earthpeople/scroll-spy/es5';

export default function scrollNavBar() {

  const mobChapNav = document.querySelector('.CourseSidebarToggle');

  if (mobChapNav) {
    let breadCrumb = document.querySelector('.Breadcrumb');

    let offsetHeightBreadCrumb = breadCrumb.offsetHeight === 0 ? 0 : breadCrumb.offsetHeight;
    
    const headerHeight = offsetHeightBreadCrumb +
    document.querySelector('.Header').offsetHeight

    const subscribe = startScrollSpy()
    subscribe('scroll', ({scrollTop}) => {
      if (scrollTop > headerHeight) {
        mobChapNav.classList.add('CourseSidebarToggle--show')
      } else {
        mobChapNav.classList.remove('CourseSidebarToggle--show')
      }
    })
  }
}
